import {Box} from '@mui/material';
import Logo_Binance from 'assets/binance-logo.svg';
import Logo_Mock from 'assets/logo.svg';
import Logo_Upbit from 'assets/upbit.svg';

export default function ExchangeLogo(props: {exchange: string}) {
	const {exchange} = props;

	return (
		<Box
			id="exchange-logo"
			component="img"
			src={exchange === 'binance' ? Logo_Binance : exchange === 'upbit' ? Logo_Upbit : Logo_Mock}
			alt={exchange}
			width="20px"
			height="20px"
		/>
	);
}
